import React, { useState } from "react";
import { Space, Button, Divider, Descriptions } from "antd";
import { createTransferId } from "../../../../services/create-transfer-id";
import { updateTransferIdDetails } from "../../../../services/update-transfer-id-details";
import { useOpenNotification } from "../../../../components/Notification/notification";
import "./transferIdCreateEdit.css";
import { getUserName } from "../../../../services/utils";
import { useNavigate } from "react-router-dom";

type TransferIdReadOnlyProps = {
  handleEdit: () => void;
  // handleShowListPage: () => void;
  values: any;
  createFlow: boolean;
};

const TransferIdReadOnly: React.FC<TransferIdReadOnlyProps> = ({
  handleEdit,
  values,
  createFlow,
  // handleShowListPage,
}) => {
  const [formValues] = useState(values);
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification, contextHolder } = useOpenNotification();
  const userName = getUserName();
  const navigate = useNavigate();

  const items = [
    {
      label: "Number",
      children: formValues.number,
    },
    {
      label: "Name",
      children: formValues.name,
    },
    {
      label: "Description",
      children: (
        <div style={{ whiteSpace: "pre-wrap" }}>
          {formValues.description?.replace(/\n/g, "\n")}
        </div>
      ),
    },
  ];
  const deliverables = [
    {
      label: "Names",
      children: formValues.deliverables ? (
        formValues.deliverables.map((file: any, index: number) => (
          <div key={file.fileName}>
            <span>{file.fileName}</span>
            {index !== formValues.deliverables.length - 1 && (
              <Divider style={{ margin: "8px 0" }} />
            )}
          </div>
        ))
      ) : (
        <div>No deliverables available</div>
      ),
    },
  ];

  const handleSubmit = () => {
    setLoading(true);
    if (createFlow) {
      createTransferId({
        number: formValues.number,
        name: formValues.name,
        description: formValues.description,
        deliverables: formValues.deliverables,
        createdBy: userName,
      }).then((result: any) => {
        if (result) {
          if (result === 409) {
            openNotification("error", "Transfer ID already Exists");
          } else {
            openNotification("success", "Transfer ID created successfully");
            setTimeout(() => {
              navigate("/admin/transfer-ids");
            }, 1500);
          }
        } else {
          openNotification("error", "failed to create Transfer ID");
        }
        setLoading(false);
      });
    } else {
      updateTransferIdDetails({
        number: formValues.number,
        name: formValues.name,
        description: formValues.description,
        action: "update",
        deliverables: formValues.deliverables,
        modifiedBy: userName,
      }).then((result: any) => {
        if (result) {
          openNotification("success", "Transfer ID updated successfully");
          setTimeout(() => {
            navigate("/admin/transfer-ids");
          }, 1500);
        } else {
          openNotification("error", "failed to update Transfer ID");
        }
        setLoading(false);
      });
    }
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          margin: "1rem 10rem",
          padding: "20px",
        }}
      >
        <Descriptions
          column={1}
          size="small"
          bordered
          title={`${!createFlow ? "Edit" : "Create"} Transfer ID`}
          items={items}
        />
        <br />
        <Descriptions
          column={1}
          size="small"
          layout="vertical"
          bordered
          title="Deliverables"
          items={deliverables}
        />
      </div>
      <div
        style={{
          backgroundColor: "white",
          margin: "1rem 10rem",
          padding: "20px",
        }}
      >
        <Space>
          <Button className="button" onClick={handleSubmit} loading={loading}>
            {createFlow ? "Create" : "Submit"}
          </Button>
          <Button type="default" onClick={handleEdit}>
            Edit
          </Button>
        </Space>
      </div>
      {contextHolder}
    </>
  );
};

export default TransferIdReadOnly;
